<template>
    <div class="d-flex align-center flex-wrap" style="gap: 8px;">
        <v-select v-model="preset" :items="presetItems" dense solo flat rounded hide-details
            prepend-inner-icon="mdi-calendar-month-outline" class="sod-eod-range-pill"
            style="max-width: 190px;" @change="onPresetChange" />
        <template v-if="preset === 'custom'">
            <v-text-field v-model="customFrom" type="date" dense outlined hide-details rounded
                label="From" style="max-width: 160px;" @change="onCustomChange" />
            <v-text-field v-model="customTo" type="date" dense outlined hide-details rounded
                label="To" style="max-width: 160px;" @change="onCustomChange" />
        </template>
    </div>
</template>

<script>
export default {
    name: 'SodEodDateRangePicker',
    data() {
        return {
            preset: 'last_7',
            customFrom: null,
            customTo: null,
            presetItems: [
                { text: 'Last 7 days', value: 'last_7' },
                { text: 'Last 30 days', value: 'last_30' },
                { text: 'This month', value: 'this_month' },
                { text: 'Last month', value: 'last_month' },
                { text: 'Custom', value: 'custom' },
            ],
        };
    },
    mounted() {
        const today = this.$date();
        this.customFrom = today.format('YYYY-MM-DD');
        this.customTo = today.format('YYYY-MM-DD');
        this.emitRange();
    },
    methods: {
        computeRange(preset) {
            const today = this.$date();
            switch (preset) {
                case 'last_30':
                    return { dateFrom: today.subtract(29, 'day').format('YYYY-MM-DD'), dateTo: this.$date().format('YYYY-MM-DD') };
                case 'this_month': {
                    const startOfMonth = today.startOf('month');
                    return { dateFrom: startOfMonth.format('YYYY-MM-DD'), dateTo: this.$date().format('YYYY-MM-DD') };
                }
                case 'last_month': {
                    const lastMonth = today.subtract(1, 'month');
                    return {
                        dateFrom: lastMonth.startOf('month').format('YYYY-MM-DD'),
                        dateTo: lastMonth.endOf('month').format('YYYY-MM-DD'),
                    };
                }
                case 'custom':
                    return { dateFrom: this.customFrom, dateTo: this.customTo };
                case 'last_7':
                default:
                    return { dateFrom: today.subtract(6, 'day').format('YYYY-MM-DD'), dateTo: this.$date().format('YYYY-MM-DD') };
            }
        },
        emitRange() {
            const range = this.computeRange(this.preset);
            this.$emit('change', { preset: this.preset, ...range });
        },
        onPresetChange() {
            if (this.preset !== 'custom') {
                this.emitRange();
            } else if (this.customFrom && this.customTo) {
                this.emitRange();
            }
        },
        onCustomChange() {
            if (this.preset === 'custom' && this.customFrom && this.customTo) {
                this.emitRange();
            }
        },
    },
};
</script>

<style scoped>
.sod-eod-range-pill >>> .v-input__control {
    min-height: 40px !important;
}

.sod-eod-range-pill >>> .v-input__slot {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
